var render = function render(){var _vm=this,_c=_vm._self._c;return _c('GmapMap',{staticStyle:{"width":"100%","height":"600px"},attrs:{"center":_vm.center,"zoom":15,"options":_vm.options}},[_c('GmapMarker',{attrs:{"position":_vm.marker.position,"clickable":false,"draggable":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }